var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('incoming-invoice-home',{attrs:{"incomingInvoices":_vm.incomingInvoices}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }